import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
})
export class LabelComponent extends FieldWrapper {}
